import React, { useState } from "react";
import myGif from "./footerimg/Ki5QrZeaFB.gif";

const ContactUs = () => {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple front-end validation for required fields
    if (
      form.fullName.trim() &&
      form.email.trim() &&
      form.subject.trim() &&
      form.message.trim()
    ) {
      alert("Thank you for contacting us! Your message has been submitted.");
      // Clear form (optional)
      setForm({
        fullName: "",
        email: "",
        subject: "",
        message: "",
      });
    } else {
      alert("Please fill in all the fields.");
    }
  };

  return (
    <>
      {/* Inline styles for this component */}
      <style>
        {`
        .info-box p{
        font-size: 15px;
        }
        .contact-form{
        height: 753px;}
        .info-box{
        background-color: #0063be}
        .info-box {
  background-color: #0063be !important;
  color: #ffffff !important; /* Pure white text */
}

.info-box h3, 
.info-box h5 {
  color: #ffffff !important;
  font-weight: 600;
}

.info-box p {
  color: rgba(255, 255, 255, 0.9) !important; /* Clearly readable soft white */
  font-size: 15px;
  line-height: 1.6;
}

/* Icons visibility */
.info-box .icon-box i {
  color: #ffffff !important;
}

/* Responsive Map Fix */
.info-box .ratio {
  width: 100% !important; /* Hardcoded 350px hatane ke liye */
  max-width: 100%;
  height: 200px !important; /* Mobile par height adjust karne ke liye */
  margin-top: 10px;
}

/* Social Icons color fix */
.info-box .info-item a i {
  color: #ffffff !important;
  transition: opacity 0.3s;
}

.info-box .info-item a:hover i {
  opacity: 0.7;
}

/* Responsive Padding for Mobile */
@media (max-width: 768px) {
  .info-box {
    padding: 25px 15px !important;
  }
  .info-box h3 {
    font-size: 1.4rem;
  }
}
    .info-box, .contact-form {
  height: 100% !important; /* Dono ki height same karne ke liye */
  display: flex;
  flex-direction: column;
}

.info-box {
  background-color: #0063be !important;
  color: #ffffff !important;
}

/* Form ke andar ka content space manage karne ke liye */
.contact-form form {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Taaki inputs ke beech ka gap maintain rahe */
.contact-form .row.gy-4 {
  height: 100%;
}      
        `}
      </style>
      <div className="container">
        <section className="container p-5 mt-4">
          <div className="row justify-content-between align-items-center">
            {/* Left: Text and Form */}
            <div className="col-md-6 mt-5 mb-5 mb-md-0">
              <span className="text-success fw-bold small">
                CONTACT WITH US
              </span>
              <h2 className="about-title mt-2 mb-3">
                How We Simplify Processes for Your Convenience
              </h2>
              <p className="about-description mb-4">
                Please reach out to us for tailored support regarding our
                products and services. Our team is prepared to offer the
                assistance necessary to improve your healthcare management
                experience with Log e Infotech. Contact us today.
              </p>
              <div className="row feature-list-wrapper mb-4">
                <div className="col-6">
                  <ul className="list-unstyled">
                    <li>
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Thorough Product Training
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      White Labeling Opportunities
                    </li>
                  </ul>
                </div>
                <div className="col-6">
                  <ul className="list-unstyled">
                    <li>
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Marketing &amp; Sales Support
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Partnership Manager
                    </li>
                  </ul>
                </div>
              </div>
              {/* The contact form goes here, unchanged */}
              {/* <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow-sm">
    
  </form> */}
            </div>

            {/* Right: Image/Map */}
            <div className="col-xl-6 text-center text-xl-end">
              <img
                src={myGif}
                alt="Contact support"
                className="img-fluid rounded-4 mt-2"
                style={{ maxWidth: "500px", width: "100%" }}
              />
            </div>
          </div>
        </section>
        <section id="partnership" className="container p-3 ">
          <div className=" text-center">
            <h2 className="mb-3">Why Partner with Log e Infotech?</h2>
            <p className="mb-5">
              At Log e Infotech, we believe in building sustainable, mutually
              beneficial partnerships that empower healthcare organizations
              through innovation, technology, and expertise.
            </p>
            <div className="row">
              <div className="col-md-4 mb-4">
                <div className="d-flex flex-column align-items-center px-3">
                  <div
                    className="bg-white shadow rounded-circle d-flex justify-content-center align-items-center mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-shield-check fs-2 text-success"></i>
                  </div>
                  <h5>Trusted Expertise</h5>
                  <p>
                    Leverage our extensive experience and specialized knowledge
                    in healthcare technology to drive impactful solutions.
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="d-flex flex-column align-items-center px-3">
                  <div
                    className="bg-white shadow rounded-circle d-flex justify-content-center align-items-center mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-people-fill fs-2 text-success"></i>
                  </div>
                  <h5>Comprehensive Support</h5>
                  <p>
                    Receive dedicated support from partnership managers and a
                    responsive team committed to your success.
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="d-flex flex-column align-items-center px-3">
                  <div
                    className="bg-white shadow rounded-circle d-flex justify-content-center align-items-center mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-lightning-charge fs-2 text-success"></i>
                  </div>
                  <h5>Future-Ready Solutions</h5>
                  <p>
                    Collaborate on innovative, scalable solutions designed to
                    meet the future needs of healthcare organizations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container p-4">
          
            <div className="row g-4">
              {/* Left Contact Info Box */}
          
              <div className="col-lg-5">
  <div className="info-box p-4 rounded shadow-lg">
    <h3 className="mb-3">Contact with Us</h3>
    <p>
      Regardless of whether you are an industry consultant, a
      technology provider, or a healthcare influencer, we invite
      you to become a part of our network and help introduce
      healthcare providers to the future of healthcare management.
    </p>

    {/* Items */}
    <div className="info-item d-flex align-items-start my-1">
      <div className="icon-box text-white fs-3 me-3"> {/* Changed text-dark to text-white */}
        <i className="bi bi-house"></i>
      </div>
      <div>
        <h5 className="mb-0">Company</h5>
        <p className="mb-0">Log e infotech Pvt. Ltd.</p>
      </div>
    </div>

    <div className="info-item d-flex align-items-start my-1">
      <div className="icon-box text-white fs-3 me-3">
        <i className="bi bi-geo-alt"></i>
      </div>
      <div>
        <h5 className="mb-0">Our Location</h5>
        <p className="mb-0">Shop no. 18, Srno- 81/1, bandal capital,</p>
        <p className="mb-0">Near Kothrud depo, paud road, Kothrud,</p>
        <p className="mb-0">India - MH - Pune - 411038</p>
      </div>
    </div>

    <div className="info-item d-flex align-items-start my-1">
      <div className="icon-box text-white fs-3 me-3">
        <i className="bi bi-telephone"></i>
      </div>
      <div>
        <h5 className="mb-0">Phone Number</h5>
        <p className="mb-0">+91 7773967002</p>
        <p className="mb-0">+91 7028287002</p>
      </div>
    </div>

    <div className="info-item d-flex align-items-start my-1">
      <div className="icon-box text-white fs-3 me-3">
        <i className="bi bi-envelope"></i>
      </div>
      <div>
        <h5 className="mb-0">Email Address</h5>
        <p className="mb-0">info@logesolutions.net</p>
        <p className="mb-0">contact@logesolutions.net</p>
      </div>
    </div>

    <div className="info-item d-flex align-items-start my-1">
      <div className="icon-box text-white fs-3 me-3">
        <i className="bi bi-geo-alt"></i>
      </div>
      <div className="w-100"> {/* Map Container */}
        <h5 className="mb-0">Map</h5>
        {/* Removed inline width/height from here to let CSS handle it */}
        <div className="ratio ratio-16x9 rounded shadow-sm overflow-hidden mt-2">
          {/* <iframe
            src="https://www.google.com/maps/embed?..."
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Log e Infotech Location"
          ></iframe> */}
          <iframe
                          src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d121071.04519959995!2d73.7128615!3d18.5076439!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bc2bf770a4026d9%3A0x45a1f7d09be00dab!2sShop%20no.%2018%2C%20Sr%2C%20No.%2081%2F1%2C%20Bandal%20Capital%2C%20Bus%20Depot%2C%20near%20Kothrud%2C%20Paud%20Road%2C%20Bharti%20Nagar%2C%20Kothrud%2C%20Pune%2C%20Maharashtra%20411038!3m2!1d18.5076617!2d73.7952632!5e0!3m2!1sen!2sin!4v1716812139564!5m2!1sen!2sin"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          title="Log e Infotech Location"
                        ></iframe>
        </div>
      </div>
    </div>

    {/* Connect With Us - Removed Inline dark colors */}
    <div className="info-item mt-4">
      <h5 className="mb-2">Connect With Us</h5>
      <div className="d-flex">
        <div className="icon-box me-3 fs-4">
          <a href="#"><i className="bi bi-twitter-x"></i></a>
        </div>
        <div className="icon-box me-3 fs-4">
          <a href="#"><i className="bi bi-facebook"></i></a>
        </div>
        <div className="icon-box me-3 fs-4">
          <a href="#"><i className="bi bi-instagram"></i></a>
        </div>
        <div className="icon-box me-3 fs-4">
          <a href="#"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
    </div>
  </div>
</div>

              {/* Right Contact Form */}
              <div className="col-lg-7">
                <div className="contact-form p-4 bg-white rounded shadow-lg">
                  <h3 className="mb-4">Engage with our solution expert.</h3>
                  <form className="php-email-form">
                    <div className="row gy-4">
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Name"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <select
                          name="country"
                          className="form-control"
                          required
                        >
                          <option value="" disabled selected>
                            Select Country
                          </option>
                          <option value="India">India</option>
                          <option value="USA">USA</option>
                          <option value="UK">UK</option>
                          <option value="Australia">Australia</option>
                          <option value="Canada">Canada</option>
                          <option value="Germany">Germany</option>
                          <option value="France">France</option>
                        </select>
                      </div>
                      <div className="col-md-2">
                        <input
                          type="text"
                          name="mobile_code"
                          className="form-control"
                          defaultValue="+91"
                          placeholder="Code"
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          name="mobile"
                          className="form-control"
                          placeholder="Mobile"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          name="weburl"
                          className="form-control"
                          placeholder="Website URL"
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          placeholder="City"
                        />
                      </div>
                      <div className="col-md-6">
                        <select
                          name="business"
                          id="business_select"
                          className="form-control"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Select Business Type
                          </option>
                          <option value="Clinic">Clinic</option>
                          <option value="Hospital">Hospital</option>
                          <option value="Laboratory">Laboratory</option>
                          <option value="Blood Bank">Blood Bank</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                        />
                      </div>
                      <div className="col-12">
                        <select
                          name="product"
                          id="product_select"
                          className="form-control"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Select Specialization Or Area of Expertise
                          </option>
                          <option>Medisevas Hospital ERP</option>
                          <option>Medisevas Clinic Management</option>
                          <option>Medisevas Appointment Portal</option>
                          <option>Medisevas Queue Management</option>
                          <option>
                            Medisevas HealthCare Content Management
                          </option>
                          <option>Medisevas HealthCare Analytics</option>
                          <option>Medisevas HealthCare Imaging</option>
                          <option>
                            Medisevas Homeopathic Materia Medica and Repertory
                          </option>
                          <option>
                            Medisevas Physiotherapy Appointment App
                          </option>
                          <option>Pathology Lab Management</option>
                          <option>Radiology Lab Management</option>
                          <option>Dental Lab Management</option>
                          <option>Embryology Lab Management</option>
                          <option>Blood Bank Management</option>
                          <option>Pharmacy Management</option>
                          <option>Ayurvedic Pharmacy Management</option>
                          <option>Homeopathic Pharmacy Management</option>
                          <option>Optic Shop Management</option>
                        </select>
                      </div>
                      <div className="col-12">
                        <textarea
                          name="message"
                          rows="6"
                          className="form-control"
                          placeholder="Message"
                        ></textarea>
                      </div>
                      <div className="col-12 text-center">
                        <button type="submit" className="btn btn-success">
                          Request For Free Demo
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
       
        </section>
      </div>
    </>
  );
};

export default ContactUs;
